import type { UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import type { getControllerOptions } from '@/features/controller/endpoints/controllers'
import { GET_CONTROLLER_DESCRIPTION_API, getControllerDescription } from '@/features/controller/endpoints/controllers'
import type { ControllerDescription } from '@/features/controller/types'
import { retryOnNonUserError } from '@/features/controller/utils/retryOnNonUserError'
import type { UseQueryOptions } from '@/types/queries'

export type UseControllerDescriptionQueryResult = Omit<UseQueryResult, 'data'> & {
  controllerDescription: ControllerDescription | null
}

export function controllerDescriptionQueryOptions(uuid: string, getControllerOptions?: getControllerOptions) {
  return queryOptions<ControllerDescription | null>({
    retry: retryOnNonUserError,
    queryFn: () => getControllerDescription(uuid, getControllerOptions),
    queryKey: [GET_CONTROLLER_DESCRIPTION_API, uuid],
  })
}

export function useControllerDescriptionQuery(
  uuid: string,
  options?: UseQueryOptions<ControllerDescription | null> & { getControllerOptions?: getControllerOptions },
): UseControllerDescriptionQueryResult {
  const { data, ...queryResult } = useQuery<ControllerDescription | null>({
    ...options,
    ...controllerDescriptionQueryOptions(uuid, options?.getControllerOptions),
  })

  return {
    ...queryResult,
    controllerDescription: data || null,
  }
}
